import Trans from 'next-translate/Trans'
import Image from 'next/image'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Content, HeroImage, HeroRoot } from './Hero.styles'

import * as friendlyDog from '../../../../../../../public/assets/raw-food-subscription/friendly-dog.webp'
import * as sillyDog from '../../../../../../../public/assets/raw-food-subscription/silly-dog.webp'

export const Hero = () => {
  const { t } = useTranslation()
  return (
    <HeroRoot>
      <HeroImage>
        <Image src={friendlyDog} />
      </HeroImage>
      <Content>
        <Stack direction="column" gap="3">
          <Text as="h1" size="h1" weight="bold" align="center">
            <Trans i18nKey="raw-food-subscription:hero.title" components={{ br: <br /> }} />
          </Text>
          <Text>
            <Text size="headline" weight="bold" align="center">
              {t('raw-food-subscription:hero.description')}
            </Text>
            <br />
            <br />
            <Text size="headline" weight="bold" align="center">
              {t('raw-food-subscription:hero.description2')}
            </Text>
          </Text>
        </Stack>
      </Content>
      <HeroImage>
        <Image src={sillyDog} />
      </HeroImage>
    </HeroRoot>
  )
}
